import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-brand-green-dark flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center font-display text-3xl font-semibold text-brand-cream mb-8">
          SDRC <span className="text-brand-gold">Global</span>
        </Link>
        <div className="bg-brand-cream rounded-sm p-8 md:p-10">
          <h1 className="font-display text-3xl font-medium text-brand-green">Admin Login</h1>
          <p className="text-sm text-brand-muted mt-1">Sign in to view inquiries.</p>
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs uppercase tracking-wider text-brand-muted">Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@sdrcglobal.com" />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs uppercase tracking-wider text-brand-muted">Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <button type="submit" data-testid="login-submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-brand-green text-white px-8 py-3.5 rounded-full font-medium hover:bg-brand-green-dark transition-colors disabled:opacity-60">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
